import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else if (id === 'accueil') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          
          {/* Company Info */}
          <div>
            <img 
              src="/innova-logo.png" 
              alt="Innova-Solution" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Services technologiques professionnels pour PME au Québec
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-[#FF6B35] rounded-lg flex items-center justify-center transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-[#FF6B35] rounded-lg flex items-center justify-center transition-colors">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-white">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('accueil')} className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  Accueil
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  Services TI
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('telephonie')} className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  Téléphonie
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('produits')} className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  Nos Produits
                </button>
              </li>
              <li>
                <a href="/supportit" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  Support IT
                </a>
              </li>
              <li>
                <a href="/admin" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm flex items-center gap-1">
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  Panneau Admin
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4 text-white">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Infrastructure TI</li>
              <li>Cybersécurité</li>
              <li>Téléphonie VoIP</li>
              <li>Sauvegarde & Cloud</li>
              <li>Support 24/7</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold mb-4 text-white">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+14503599394" className="flex items-center gap-2 text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  <Phone className="w-4 h-4" />
                  (450) 359-9394
                </a>
              </li>
              <li>
                <a href="mailto:info@innova-solution.ca" className="flex items-center gap-2 text-gray-400 hover:text-[#FF6B35] transition-colors text-sm">
                  <Mail className="w-4 h-4" />
                  info@innova-solution.ca
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>855 Ch. du Grand Bernier N<br />Suite 300<br />Saint-Jean-sur-Richelieu, QC</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          {/* Ubiquiti Badge */}
          <div className="flex justify-center mb-6">
            <div className="inline-flex items-center gap-3 glass px-6 py-3 rounded-full border border-[#FF6B35]/30">
              <img 
                src="/images/partners/ubiquiti-horizontal-light.png" 
                alt="Ubiquiti" 
                className="h-6 w-auto"
              />
              <div className="w-px h-6 bg-white/20"></div>
              <span className="text-sm font-semibold text-gray-300">
                Distributeur Officiel & Installateur Autorisé
              </span>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Innova-Solution. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <button className="text-gray-500 hover:text-[#FF6B35] transition-colors">
                Politique de confidentialité
              </button>
              <button className="text-gray-500 hover:text-[#FF6B35] transition-colors">
                Conditions d'utilisation
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
